"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadSendAsFail = exports.loadSendAsSuccess = exports.loadSendAsRequest = void 0;

var _sendAs = require("./send-as.types");

var loadSendAsRequest = function loadSendAsRequest(teamId) {
  return {
    type: _sendAs.GIFT_CREATE_LOAD_SEND_AS_REQUEST,
    payload: teamId
  };
};

exports.loadSendAsRequest = loadSendAsRequest;

var loadSendAsSuccess = function loadSendAsSuccess(users) {
  return {
    type: _sendAs.GIFT_CREATE_LOAD_SEND_AS_SUCCESS,
    payload: users
  };
};

exports.loadSendAsSuccess = loadSendAsSuccess;

var loadSendAsFail = function loadSendAsFail(error) {
  return {
    type: _sendAs.GIFT_CREATE_LOAD_SEND_AS_FAIL,
    payload: error
  };
};

exports.loadSendAsFail = loadSendAsFail;